package com.macrofocus.eflux.data.quest

import com.macrofocus.common.units.*
import com.macrofocus.eflux.data.BusPowerFlowRecord
import org.molap.dataframe.DataFrame

class QuestBusPowerFlowRecord(private val dataFrame: DataFrame<Int,String,Any?>, private val row: Int, private val suffix: String = "") : BusPowerFlowRecord {
    override val datetime: Any
        get() = dataFrame.getValueAt(row, "datetime") as Any
    override val i: String
        get() = dataFrame.getValueAt(row, "busId$suffix") as String
    override val name: String
        get() = dataFrame.getValueAt(row, "busId$suffix") as String
    override val baskv: Quantity<Voltage>
        get() = (dataFrame.getValueAt(row, "baskv$suffix") as Double).into(Voltage.Kilovolt)
    override val ide: Double
        get() = dataFrame.getValueAt(row, "ide$suffix") as Double
    override val area: Int
        get() = dataFrame.getValueAt(row, "area$suffix") as Int
    override val zone: Int
        get() = (dataFrame.getValueAt(row, "zone$suffix") as Number).toInt()
    override val owner: Double
        get() = dataFrame.getValueAt(row, "owner$suffix") as Double
    override val vm: Quantity<PerUnit>
        get() = (dataFrame.getValueAt(row, "vm$suffix") as Double).into(PerUnit.pu)
    override val va: Quantity<PhaseAngle>
        get() = (dataFrame.getValueAt(row, "va$suffix") as Double).into(PhaseAngle.Degree)
    override val nvhi: Quantity<PerUnit>
        get() = (dataFrame.getValueAt(row, "nvhi$suffix") as Double).into(PerUnit.pu)
    override val nvlo: Quantity<PerUnit>
        get() = (dataFrame.getValueAt(row, "nvlo$suffix") as Double).into(PerUnit.pu)
    override val evhi: Quantity<PerUnit>
        get() = (dataFrame.getValueAt(row, "evhi$suffix") as Double).into(PerUnit.pu)
    override val evlo: Quantity<PerUnit>
        get() = (dataFrame.getValueAt(row, "evlo$suffix") as Double).into(PerUnit.pu)
}